import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

/**
 * Store presence (utenti connessi). Popolato dall'heartbeat `usePresence`.
 *
 * - Contesto admin: riceve { app, admin } separati → mostrati in AdminShell.
 * - Contesto pubblico: riceve solo la somma { online } → mostrata nella modale
 *   info della Home. `online` usa la somma diretta app+admin quando disponibile,
 *   altrimenti l'override ricevuto dal ping pubblico.
 */
export const usePresenceStore = defineStore('presence', () => {
  const app = ref(0)
  const admin = ref(0)
  const publicOnline = ref(null)

  const online = computed(() =>
    publicOnline.value != null ? publicOnline.value : app.value + admin.value
  )

  function setFromAdmin (counts) {
    app.value = counts?.app ?? 0
    admin.value = counts?.admin ?? 0
    publicOnline.value = null
  }

  function setFromPublic (payload) {
    publicOnline.value = payload?.online ?? 0
  }

  return { app, admin, online, setFromAdmin, setFromPublic }
})
